import { useEffect, useRef } from 'react';

/**
 * Custom hook to listen for scroll target ref from LIFE_CYCLE_EVENT_BUS
 * Used in MFA architecture to receive scroll target refs from other components
 *
 * @returns {React.MutableRefObject} scrollTargetRef - Ref object containing the scroll target element
 */
export const usePlpResultsHeaderReadyEvent = () => {
  const scrollTargetRef = useRef(null);

  useEffect(() => {
    const handleScrollingRef = ({ output }) => {
      if (output?.ref) {
        scrollTargetRef.current = output.ref;
      }
    };

    // Listen to the 'plp-results-header.ready' event on the lifecycle bus
    window.LIFE_CYCLE_EVENT_BUS.on('plp-results-header.ready', handleScrollingRef);

    // Cleanup: remove the event listener when component unmounts
    return () => {
      if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
        window.LIFE_CYCLE_EVENT_BUS.off('plp-results-header.ready', handleScrollingRef);
      }
    };
  }, []);

  return scrollTargetRef;
};
